/* eslint-disable camelcase */
import { ACTIVE_URL } from 'aurora-utils/constants';

const { BASE_URL } = ACTIVE_URL;

const v1 = 'v1';
const v1_1 = 'v1_1';

const MODULES = {
  GUESTUSER: '/authentication-service/oauth2/token',
  AUTHUAEPASS: `/authentication-service/api/${v1}/user`,
  AUTH: `/authentication-service/api/${v1}`,
  USER: `/api/${v1}/user`,
  ACCOUNT: `/api/${v1}/account`,
  PROPERTY1: `/api/${v1}/projection`,
  SERVICE: `/api/${v1}/services`,
  DOCUMENT: `/document-service/api/${v1}`,
  PROPERTY_SERVICE: `property-service/api/${v1}`,
  WALLET: `/payment-service/api/${v1}/payment/wallet`,
  PAYMENT: `/payment-service/api/${v1}/payment`,
  PROJECTION: `/api/${v1}/projection`,
  TASK: `/api/${v1}/task`,
  PROPERTY: `/property-service/api/${v1}`,
  WORKFLOW: `/workflow-service/api/${v1}`,
  LEASE: `/lease-service/api/${v1}`,
  LEASE_V1_1: `/lease-service/api/${v1_1}`,
  SELLPURCHASE: `/sale-service/api/${v1}`,
  SELLPURCHASE_V1_1: `/sale-service/api/${v1_1}`,
  OWNER: `/owner-service/api/${v1}`,
  PMA: `/lease-service/api/${v1}/pma`,
  DRC: `/dispute-service/api/${v1}`,
  CERTIFICATE: `/lease-service/api/${v1}/pma`,
  ADMINPAYMENT: `/payment-service/admin/offline/payment`,
  DOT_NET_V1: '/dotnet/api/v1',
};

const AUTH = {
  GUEST_USER: `${MODULES.GUESTUSER}`, // POST
  LOGIN_WITH_OTP: `${MODULES.AUTH}/user/moi/otp`, // POST
  LOGIN_WITH_UAE_PASS: `${MODULES.AUTHUAEPASS}/uae-pass/login`, // POST
  VERIFY_OTP_UAE_PASS: `${MODULES.AUTHUAEPASS}/uae-pass/verify/otp`, // POST
  RESEND_OTP_UAE_PASS: `${MODULES.AUTHUAEPASS}/uae-pass/otp/resend`, // POST
  VERIFY_OTP: `${MODULES.AUTH}/user/moi/verify/otp`, // POST
  RESEND_OTP: `${MODULES.AUTH}/user/moi/otp/resend`, // POST
  CONTACT_US: `${MODULES.AUTH}/contact-us/save`, // POST
  MARKET_DATA_TOKEN: `${MODULES.PROPERTY_SERVICE}/carousel/general/b2c/generate-token`,
  INSURANCE_COMPANY: `${MODULES.AUTH}/lookup/insurance-company`,
  EMIRATES_SOURCE: `${MODULES.AUTH}/lookup/emirate`,
  FETCH_OFF_PLAN_PROJECTS: `${MODULES.PROPERTY_SERVICE}/lookup/projects`,
  FETCH_OFF_PLAN_UNIT_USAGE: `${MODULES.PROPERTY_SERVICE}/lookup/unit-uses`,
  FETCH_OFF_PLAN_LAND_USAGE: `${MODULES.PROPERTY_SERVICE}/lookup/land-uses`,
  FETCH_CERTIFICATE_TYPES: `${MODULES.WORKFLOW}/application/lookup/certificate-types`,
  FETCH_PROPERTY_PROJECTS: `${MODULES.PROPERTY_SERVICE}/lookup/property-projects`,

  FETCH_OFF_PLAN_UNIT_TYPES: `${MODULES.PROPERTY_SERVICE}/lookup/unit-types`,
  VERIFY_EMAIL: `${MODULES.AUTH}/user/non-uae/verify-email`,
  CREATE_PASSWORD: `${MODULES.AUTH}/user/non-uae/create-password`,
  LOGIN_WITH_EMAIL: `${MODULES.AUTHUAEPASS}/non-uae/login`, // POST
  VERIFY_OTP_NON_UAE: `${MODULES.AUTH}/user/non-uae/verify-otp`, // POST
  FORGOT_PASSWORD: `${MODULES.AUTH}/user/non-uae/forgot-password`, // POST
  RESET_PASSWORD: `${MODULES.AUTH}/user/non-uae/reset-password`, // POST
  VERIFY_LINK: `${MODULES.AUTH}/user/non-uae/verify-link`, // POST
};

const PROJECTION = {
  LANDING: `${MODULES.PROJECTION}/landing`, // GET
  PROPERTY: `${MODULES.PROJECTION}/property`, // GET
  NOTIFICATION: `${MODULES.PROJECTION}/notification`, // GET
  WALLET: `${MODULES.PROJECTION}/wallet`, // GET
  TASKS: `${MODULES.PROJECTION}/tasks`, // GET
  TASK_LIST: `${MODULES.TASK}`,
  OFF_PLAN_TERMINATION_TASK_LIST: `${MODULES.TASK}/offplan-termination-task`,
};
const ACCOUNT = {
  IDENTITY: `${MODULES.ACCOUNT}/identity`, // GET
};

const WALLET = {
  TRANSACTIONS: `${MODULES.WALLET}/transaction/history`, // GET
  TRANSACTION_DETAILS: `${MODULES.WALLET}/transaction/details`, // GET
  PAY_AMOUNT: `${MODULES.WALLET}/transaction`, // POST
  BALANCE: `${MODULES.WALLET}/balance`, // GET
};

const WORKFLOW = {
  CAROUSEL: `${MODULES.WORKFLOW}/carousel/screen`, // GET
  SERVICE_LIST: `${MODULES.WORKFLOW}/workflow/apptype-persona`, // GET
  FETCH_WORKFLOW: `${MODULES.WORKFLOW}/workflow/key`, // GET
  VALIDATE: `${MODULES.WORKFLOW}/validate/application`, // POST
  POST_VALIDATE: `${MODULES.WORKFLOW}/validate/post-validate`, // POST
  REGISTER_APPLICATION: `${MODULES.WORKFLOW}/application`, // POST
  FETCH_WORKFLOW_HISTORY: `${MODULES.WORKFLOW}/workflow/application`, // GET
  FETCH_WORKFLOW_HISTORY_V2: `${MODULES.WORKFLOW}/application-history/application`, // GET
  CANCEL_APPLICATION: `${MODULES.WORKFLOW}/application/cancel`, // POST
  FETCH_APPLICATION: `${MODULES.WORKFLOW}/application`, // POST
  CAROUSEL_MARKET: `${MODULES.PROPERTY_SERVICE}/carousel/market-data`, // GET
  FETCH_APPLICATION_TYPES: `${MODULES.WORKFLOW}/application/lookup/application-type`, // GET
  UPDATE_HAPPYNESS_METER_FEEDBACK: `${MODULES.WORKFLOW}/application/happiness-meter`, // POST
  ETISALAT_LEAD: `${MODULES.LEASE}/application/etisalat-lead`, // GET
};

const PROPERTY = {
  PROPERTIES: `${MODULES.PROPERTY1}/user`,
  PROPERTY: `${MODULES.PROPERTY}/property`,
  EVALUATION: `${MODULES.PROPERTY}/property-valuation`, // GET
  OWNER: `${MODULES.PROPERTY}/ownership-property`, // GET
  PROJECTS: `${MODULES.PROPERTY}/property/project`, // GET
  PROJECT_BY_ID: `${MODULES.PROPERTY}/property/project`, // GET
  PROFESSIONS: `${MODULES.PROPERTY}/property/profession`, // GET
  PROFESSION_BY_ID: `${MODULES.PROPERTY}/property/profession`, // GET
  UNITS_BY_BUILDING_ID: `${MODULES.PROPERTY}/units-by-building`, // GET
  PROFESSION_BY_LICENSE_NUMBER: `${MODULES.PROPERTY}/property/professionByLicense`, // GET
  PROJECT_BY_PROGRESS_REPORT: `${MODULES.PROPERTY}/directory/property/project-progress-report`, // GET
  PROJECT_BY_SERVICE_CHARGES: `${MODULES.PROPERTY}/directory/property/project-service-charges`, // GET
};

const DEVELOPER = {
  PROJECTS: `${MODULES.PROPERTY}/developer/property/project`, // GET
  ESCROW_PROJECTS: `${MODULES.PROPERTY}/developer/property/elms-project`, // POST
  PROJECT_BY_PROJECT_INFORMATION: `${MODULES.PROPERTY}/developer/property/project`, // GET
  PROJECT_BY_FINANCIAL_SUMMARY: `${MODULES.PROPERTY}/property/project-financial-summary`, // GET
  PROJECT_BY_FINANCIAL_TRANSACTION: `${MODULES.PROPERTY}/property/project-financial-transactions`, // GET
  PROJECT_BY_PROGRESS_REPORT: `${MODULES.PROPERTY}/developer/property/project-progress-report`, // GET
  PROJECT_BY_SERVICE_CHARGES: `${MODULES.PROPERTY}/developer/property/project-service-charges`, // GET
  PROJECT_UNITS: `${MODULES.PROPERTY}/developer/property/project-units`, // GET
  PROJECT_TRANSACTION_DOWNLOAD: `${MODULES.PROPERTY}/property/project-financial-transactions/download`,
  CERTIFICATE_DOWNLOAD: `${MODULES.PROPERTY}/property/escrow-agreement/download`,
};

const USER = {
  PROFILE: `${MODULES.USER}/profile`, // GET
  SWITCH_PROFILE: `${MODULES.USER}/profile-switch`, // GET
  DOWNLOAD_DOCUMENT: `${MODULES.DOCUMENT}/document/download-user-documents`,
};

const PROPERTY_SERVICE = {
  PROPERTIES: `${MODULES.PROPERTY_SERVICE}/properties`,
  OWNERSHIP_PROPERTIES: `${MODULES.PROPERTY_SERVICE}/owner-properties`,
  LEASE_PROPERTIES: `${MODULES.PROPERTY_SERVICE}/lease-properties`,
  MORTGAGE_PROPERTIES: `${MODULES.PROPERTY_SERVICE}/mortgage/bank-properties`,
  LEASE_PROPERTIES_PMA: `${MODULES.PROPERTY_SERVICE}/lease-properties-pma`,
  LEASE_PROPERTY: `${MODULES.PROPERTY_SERVICE}/lease-property`,
  MAP_PROPERTY: `${MODULES.PROPERTY_SERVICE}/property/map`,
};

const PAYMENT = {
  WALLET_TOP_UP: `${MODULES.PAYMENT}/wallet/topup`, // POST
  CONFIRM_PAYMENT: `${MODULES.PAYMENT}/confirm-payment`, // POST
  TRANSACTIONS: `${MODULES.PAYMENT}/user-payments`, // GET
  PAYMENT_FEES: `${MODULES.PAYMENT}`, // GET
  MAKE_PAYMENT: `${MODULES.PAYMENT}/make-payment`, // GET
  AMENDMENT_FEE: `${MODULES.PAYMENT}/amendment-charges`, // GET
  FETCH_PAYMENT_RECEIPT: `${MODULES.PAYMENT}/application/payment-receipts`, // GET
  FETCH_PAYMENT_BREAKDOWN: `${MODULES.PAYMENT}/breakdown`, // POST
  ADMIN_PAYMENT: `${MODULES.ADMINPAYMENT}/breakdown`, // POST
  ADMIN_MAKE_PAYMENT: `${MODULES.ADMINPAYMENT}/make-payment`, // POST
};

const DOCUMENT = {
  UPLOAD_DOCUMENT: `${MODULES.DOCUMENT}/document/upload`,
  DELETE_DOCUMENT: `${MODULES.DOCUMENT}/document`, // DELETE
  DOCUMENT_COMPLETE: `${MODULES.DOCUMENT}/document/step/complete`,
  FETCH_DOCUMENTS: `${MODULES.DOCUMENT}/document/fetch`,
  DOWNLOAD_DOCUMENT: `${MODULES.DOCUMENT}/document/download`,
  FETCH_DOCUMENT_CONFIG: `${MODULES.DOCUMENT}/document/fetch/config`,
  FETCH_REQUIRED_COMPANY_DOCS: `${MODULES.DOCUMENT}/document/upload/fetch`,
  DOWNLOAD_CERTIFICATE: `${MODULES.SELLPURCHASE}/application/certificate/download`,
  DOWNLOAD_TITLE_DEED: `${MODULES.SELLPURCHASE}/download/deed-certificate`,
  DOWNLOAD_DOCUMENT_OFFPLAN: `${MODULES.SELLPURCHASE}/application/off-plan/contract/download`, // GET
  DOWNLOAD_CONTRACT_MUSATAHA: `${MODULES.SELLPURCHASE}/application/waiver-musataha/download/contract`, // GET
  // DOWNLOAD_ELMS_DOCUMENT: `${MODULES.DOCUMENT}/document/elms-doc-download`,
  BLOCKCHAIN_VERIFICATION: `${MODULES.DOCUMENT}/document/blockchain/verify`, // GET
};
const LEASE = {
  APPLICATION_DETAILS: `${MODULES.LEASE}/application/lease-registration`, // GET
  PREMISE_DETAILS: `${MODULES.LEASE}/application/premise-detail`, // GET
  USER_DETAILS: `${MODULES.LEASE}/application/lease-registration/user`, // GET
  APPLICATION_PDF: `${MODULES.LEASE}/application/lease-contract/download`, // GET
  APPLICATION_PDF_CONTRACT: `${MODULES.LEASE}/application/lease-contract/final/download`, // GET
  APPLICATION_PDF_CONTRACT_PMA: `${MODULES.LEASE}/pma/contract/download`, // GET
  REGISTRATION: `${MODULES.LEASE}/application/lease-registration`, // POST
  ADD_OCCUPANT: `${MODULES.LEASE}/application/contract-occupant`, // POST
  REMOVE_OCCUPANT: `${MODULES.LEASE}/application/remove-occupant`, // DELETE
  TENANT_APPROVAL: `${MODULES.LEASE}/application/tenant-approval`, // POST (version v1_1)
  CHECKOUT: `${MODULES.LEASE}/application/checkout`, // POST
  OWNER_APPROVAL: `${MODULES.LEASE}/application/owner-approval`, // POST
  CONTRACTS: `${MODULES.LEASE}/lease-search`, // POST
  OTHER_OWNER_APPROVAL: `${MODULES.LEASE}/application/owner-approval`, // POST (version v1_1)
  CLOSURE: `${MODULES.LEASE}/application/close/initiate`, // POST
  CANCELLATION: `${MODULES.LEASE}/application/cancellation/initiate`, // POST
  CANCELLATION_TENANT_APPROVAL: `${MODULES.LEASE}/application/cancellation/tenant-approval`, // POST (version v1_1)
  CANCELLATION_OWNER_APPROVAL: `${MODULES.LEASE}/application/cancellation/owner-approval`, // POST
  ADD_PRIMARY_LESSOR: `${MODULES.LEASE}/application/primary-lessor`, // POST
  FETCH_OCCUPANT_RELATIONS: `${MODULES.LEASE}/application/ocuupant-relation/lookup`, // GET
  TERMINATION_COURT: `${MODULES.LEASE}/application/contract-terminate-court-order`, // POST
  CLOSURE_TENANT: `${MODULES.LEASE}/application/close/tenant-approval`, // POST
  CLOSURE_OWNER: `${MODULES.LEASE}/application/close/owner-approval`, // POST
  FETCH_USER_BY_ID_LEASE: `${MODULES.LEASE}/application/lease-registration/user`, // GET
  GET_ONWANI_ADDRESS: `${MODULES.LEASE}/application/onwani-address`, // GET
  ADD_PROPERTIES: `${MODULES.LEASE}/application/lease/add-properties`, // POST
  GET_SELECTED_PROPERTIES: `${MODULES.LEASE}/application/properties`, // GET
  REMOVE_UNIT: `${MODULES.LEASE}/application/remove-properties `, // DELETE
  GET_ONWANI_ADDRESSES: `${MODULES.LEASE}/application/onwani-addresses`, // pOST
  GET_CONTRACT_AMOUNT: `${MODULES.WORKFLOW}/application/contract-annual-amount`, // POST
  LEASE_CONTRACT_PREVIEW: `${MODULES.LEASE}/application/lease-contract/preview`, // GET
  UPDATE_SUBLEASE_PERMISSIONS: `${MODULES.LEASE}/update-sublease-permissions`, // GET
};

const SELLPURCHASE = {
  APPLICATION_DETAILS: `${MODULES.SELLPURCHASE}/application/sell-purchase`, // GET
  DMT_LOCATION: `${MODULES.SELLPURCHASE}/appointment/locations`, // GET
  DMT_SLOTS: `${MODULES.SELLPURCHASE}/appointment/slots`, // GET
  DMT_BOOKING: `${MODULES.SELLPURCHASE}/appointment`, // POST
  SELLER_TERMINATION: `${MODULES.SELLPURCHASE}/application/terminate`,
  SUBMIT_APPLICATION: `${MODULES.SELLPURCHASE}/application/submit`, // GET
  DELETE_REPRESENTATIVE: `${MODULES.SELLPURCHASE}/application/representative`, // DELETE
  FETCH_APPLICATION_WAIVE_MUSATAHA: `${MODULES.SELLPURCHASE}/application/waiver-musataha`, // GET
  SAVE_APPLICATION_MUSATAHA_WAIVER: `${MODULES.SELLPURCHASE}/application/waiver-musataha`, // POST
  EVALUATION_PRICE: `${MODULES.SELLPURCHASE}/application/sell-purchase`,
  FEE_CALCULATE: `${MODULES.SELLPURCHASE}/application/sell-purchase`,
  APPOINMENT_LOCATION: `${MODULES.SELLPURCHASE}/appointment/locations`,
  WORKING_HOURS: `${MODULES.SELLPURCHASE}/appointment`,
  COMMON_ENDPOINT: `${MODULES.SELLPURCHASE}/application/sell-purchase`,
  SAVE_APPOINMENT_SALE: `${MODULES.SELLPURCHASE}/application/sell-purchase`,
  ADD_BROKER: `${MODULES.SELLPURCHASE}/application/sell-purchase`, // POST
  CHECKOUT: `${MODULES.SELLPURCHASE}/application/sell-purchase`,
  SELLER_APPROVAL: `${MODULES.SELLPURCHASE}/application/sell-purchase/seller-approval`,
  BUYER_APPROVAL: `${MODULES.SELLPURCHASE}/application/sell-purchase/buyer-approval`,
  PROPERTY: `${MODULES.SELLPURCHASE}/application/sell-purchase`,
  FETCH_BREAKDOWN: `${MODULES.PAYMENT}/sell-purchase/payment-breakdown`,
  INITIATE_SIGNING_CONTRACT: `${MODULES.WORKFLOW}/signing/initiate-signing-process`,
  DOWNLOAD_CONTRACT: `${MODULES.WORKFLOW}/signing/download-signing-contract`,
};

const OWNER = {
  SEARCH_OWNER: `${MODULES.OWNER}/search-owner`, // POST
  ADD_BUYER: `${MODULES.SELLPURCHASE}/application/off-plan/party/buyer`, // POST
  ADD_BUYER_PERSON: `${MODULES.OWNER}/buyer`, // POST
  ADD_BUYER_COMPANY: `${MODULES.OWNER}/buyer-company`, // POST
  FETCH_OWNER: `${MODULES.OWNER}/owner`, // GET
  FETCH_LEGAL_FORMS: `${MODULES.OWNER}/legal-form/lookup`, // GET
  FETCH_LICENSE_SOURCES: `${MODULES.OWNER}/trade-license-source/lookup`, // GET
  VALIDATE_COMPANY: `${MODULES.OWNER}/company-exists`, // GET
  FETCH_COMPANY_DETAILS: `${MODULES.OWNER}/fetch-company`, // GET
  FETCH_COMPANY_BY_LICENSE: `${MODULES.OWNER}/fetch-company/license`, // GET
  FETCH_COMPANY_RESERVE: `${MODULES.OWNER}/fetch-company/reserser`, // GET
  ADD_COMPANY: `${MODULES.OWNER}/add-company`, // POST
  SUBMIT_COMPANY_APPLICATION: `${MODULES.OWNER}/submit`, // POST
  ADD_OWNER_INDIVIDUAL: `${MODULES.OWNER}/poa/owner-individual`, // POST
  ADD_OWNER_COMPANY: `${MODULES.OWNER}/poa/owner-company`, // POST
  ADD_REPRESENTATIVE: `${MODULES.OWNER}/add-representative`, // POST
  FETCH_POA_DETAILS: `${MODULES.OWNER}/fetch-poa`, // GET
  FETCH_POA_BY_ID: `${MODULES.OWNER}/fetch-poa/by-poa-number`, // GET
  FETCH_POA_TYPES: `${MODULES.OWNER}/poa-type/lookup`, // GET
  ADD_POA: `${MODULES.OWNER}/add-poa`, // POST
  SUBMIT_POA: `${MODULES.OWNER}/poa/submit`, // POST
  FETCH_OWNER_BY_ID: `${MODULES.OWNER}/owner`, // GET
  SAVE_EMPLOYEE: `${MODULES.OWNER}/employee/save-employee`, // POST
  REMOVE_EMPLOYEE_PROPERTY: `${MODULES.OWNER}/employee/remove-property`, // DELETE
  FETCH_EMPLOYEE_PROPERTIES: `${MODULES.OWNER}/employee/properties`, // POST
  FETCH_EMPLOYEE_LIST: `${MODULES.OWNER}/employee/company-employees`, // GET
  DELETE_EMPLOYEE: `${MODULES.OWNER}/employee/final/delete-employee`, // Delete
  DEACTIVATE_EMPLOYEE: `${MODULES.OWNER}/employee/final/deactivate-employee`, // PUT
  REACTIVATE_EMPLOYEE: `${MODULES.OWNER}/employee/final/reactivate-employee`, // PUT
  FETCH_EMPLOYEE: `${MODULES.OWNER}/employee/final/fetch-employee`, // GET
  FETCH_EMPLOYEE_PROPERTIES_USERID: `${MODULES.OWNER}/employee/final/properties`, // GET
  FETCH_EMPLOYEE_PERMISSIONS: `${MODULES.OWNER}/employee/permission`, // GET
  FETCH_EMPLOYEE_APPLICATION: `${MODULES.OWNER}/employee/fetch-employee`, // GET
  FINAL_EMPLOYEE_SAVE: `${MODULES.OWNER}/employee/final/save-employee`, // POST
  CHECKOUT_EMPLOYEE_FORM: `${MODULES.OWNER}/employee/checkout`, // GET
  ADD_BUYER_PERSON_MUSATAHA: `${MODULES.OWNER}/party/buyer`, // POST
  FETCH_POA_OWNERS: `${MODULES.OWNER}/fetch-poa-customers`, // GET
  ADD_BROKER: `${MODULES.SELLPURCHASE}/application/off-plan/party/broker`, // POST
  ADD_OFFPLAN_POA: `${MODULES.OWNER}/party/poa`, // POST
  FETCh_PROFILE_ENABLED_SERVICES: `${MODULES.OWNER}/employee/fetch-profile-enabled-services`,
  FETCH_GOVERNMENT_COMPANIES: `${MODULES.OWNER}/fetch-govt-companies`,
  FETCH_USER_BY_ID: `${MODULES.OWNER}/user`, // GET
  FETCH_NON_UAE_USER: `${MODULES.OWNER}/non-resident-user`, // GET
  FETCH_CN_IN_COMPANY: `${MODULES.OWNER}/fetch-company/license`, // GET
  FETCH_GOV_COMPANIES: `${MODULES.OWNER}/fetch-govt-companies`, // GET
  SAVE_PARTIES_DETAILS_TO_DB_USERS_TABLE: `${MODULES.OWNER}/users-companies/email-phone/update`, // POST
  CHECK_COMPANY_ADMIN: `${MODULES.OWNER}/employee/check-company-admin`, // GET
};
const PMA = {
  APPLICATION_DETAILS: `${MODULES.PMA}/application/pma-registration`,
  SAVE_PMA_APPLICATION: `${MODULES.PMA}/application/pma-registration`,
  CHECKOUT_PMA_APPLICATION: `${MODULES.PMA}/application/checkout`,
  BUILDINGS: `${MODULES.PMA}/application/buildings`,
  UNITS: `${MODULES.PMA}/application/units`,
  VALIDATE: `${MODULES.PMA}/application/validate-properties`,
  ADD_PROPERTIES: `${MODULES.PMA}/application/add-properties`,
  DELETE_PROPERTIES: `${MODULES.PMA}/application/remove-properties`,
  GET_BUILDINGS_BY_PAGE: `${MODULES.PMA}/application/buildings`,
  GET_UNITS_BY_PAGE: `${MODULES.PMA}/application/units`,
  OWNER_APPROVAL: `${MODULES.PMA}/application/owner-final-approval`, // POST
  OTHER_OWNER_APPROVAL: `${MODULES.PMA}/application/owner-approval`, // POST
  PARTIES_APPROVAL: `${MODULES.PMA}/application/pma-approval`, // POST (version v1_1)
  BANK_APPROVAL: `${MODULES.PMA}/application/bank-approval`,
  BANK_APPROVAL_TERMINATION: `${MODULES.PMA}/application/cancellation/bank-approval`,
  APPLICATION_PDF: `${MODULES.PMA}/contract/download`, // GET
  PMA_CANCELLATION: `${MODULES.PMA}/application/cancellation/initiate`, // GET
  CANCELLATION_PARTIES_APPROVAL: `${MODULES.PMA}/application/cancellation/pma-approval`,
  CANCELLATION_OWNER_APPROVAL: `${MODULES.PMA}/application/cancellation/owner-approval`,
  PAYMENT_BREAKDOWN: `${MODULES.PAYMENT}/breakdown`, // GET
  REJECT_WITH_REASON: `${MODULES.WORKFLOW}/application/cancel`,
  CONTRACT_PDF: `${MODULES.LEASE}/pma/contract/download`, // GET
};
const CONTRACTLISTING = {
  CONTRACTS: `${MODULES.LEASE}/lease-search`, // POST
  CONTRACT_DETAIL: `${MODULES.LEASE}/application/final-contract`, // GET
  CONTRACT_DETAIL_PMA: `${MODULES.LEASE}/pma/final-contract`, // GET
  CONTRACT_DETAIL_PMA_BUILDINGS: `${MODULES.LEASE}/pma/final-contract/buildings`, // GET
  CONTRACT_DETAIL_PMA_BUILDING_UNITS: `${MODULES.LEASE}/pma/final-contract/units-by-building`, // GET
  VERIFY_CONTRACT: `${MODULES.LEASE}/contract/verify-contract`,
  CONTRACT_TYPES: `${MODULES.LEASE}/lookup/contract-classification`,
  CONTRACT_LISTING_OFFPLAN: `${MODULES.SELLPURCHASE}/application/off-plan/contracts/search`, // POST
  CONTRACT_DETAIL_OFFPLAN: `${MODULES.SELLPURCHASE}/application/off-plan/contract`, // GET
  CONTRACT_LISTING_MUSATAHA: `${MODULES.SELLPURCHASE}/application/waiver-musataha/contracts/search`, // POST
  MUSATAHA_LAND_USE: `${MODULES.SELLPURCHASE}/application/waiver-musataha/land-uses`, // GET
  CONTRACT_DETAIL_MUSATAHA: `${MODULES.SELLPURCHASE}/application/waiver-musataha/contract`, // GET
  CONTRACT_DETAIL_MUSATAHA_INDIVIDUAL: `${MODULES.PROPERTY_SERVICE}/interpersonal-musataha-contract`, // GET
  LEASE_PROPERTIES: `${MODULES.LEASE}/contract/properties`, // POST
  CONTRACT_LISTING_MORTGAGE: `${MODULES.SELLPURCHASE}/mortgage/contract-search`, // POST

  POA_CONTRACT_LIST: `${MODULES.OWNER}/poa/contract-search`, // POST
};
const MUSATAHA = {
  MUSATAHA_PAYMENT_BREATDOWN: `${MODULES.PAYMENT}/long-lease-to-musataha-payment-breakdown`,
  SAVE_MUSATAHA_APPLICATION: `${MODULES.SELLPURCHASE}/application/long-lease-to-musataha/contract`,
  CHECKOUT_MUSATAHA_APPLICATION: `${MODULES.SELLPURCHASE}/application/long-lease-to-musataha/checkout`,
  GET_MUSATAHA_APPLICATION_CONTRACT: `${MODULES.SELLPURCHASE}/application/long-lease-to-musataha`,
  APPROVE_MUSATAHA_APPLICATION: `${MODULES.SELLPURCHASE}/application/long-lease-to-musataha/tenant-approval`,
  CHECKOUT_MUSATAHA_APPLICATION_WAIVE: `${MODULES.SELLPURCHASE}/application/waiver-musataha/checkout`,
  MUSATAHA_PAYMENT_BREATDOWN_WAIVER: `${MODULES.PAYMENT}/waiver-musataha-payment-breakdown`,
  BUYER_APPROVE_MUSATAHA: `${MODULES.SELLPURCHASE}/application/waiver-musataha/buyer-approval`,
  OWNER_APPROVE_MUSATAHA: `${MODULES.SELLPURCHASE}/application/waiver-musataha/seller-approval`,
  APPLICATION_PDF: `${MODULES.SELLPURCHASE}/application/waiver-musataha/waiver-certificate/download`,
  MUSATAHA_APPLICATION_PDF: `${MODULES.SELLPURCHASE}/application/long-lease-to-musataha/contract/download`,
  MUSATAHA_PROPERTY_DOCUMENTS: `${MODULES.PROPERTY_SERVICE}/property/latest-document`,
  APPLICATION_PDF_TENANT: `${MODULES.SELLPURCHASE}/application/waiver-musataha/contract/download`,
};
const TRANSFER_OF_INTEREST = {
  TRANSFER_OF_INTEREST: `${MODULES.SELLPURCHASE}/application/transfer-interest`, // GENERAL
  OFFPLAN_SELL_PAYMENT_BREAKDOWN: `${MODULES.PAYMENT}/offplan-first-sell-payment-breakdown`,
  MUSATAHA_PAYMENT_BREATDOWN: `${MODULES.PAYMENT}/long-lease-to-musataha-payment-breakdown`,
  SAVE_MUSATAHA_APPLICATION: `${MODULES.SELLPURCHASE}/application/long-lease-to-musataha/contract`,
  CHECKOUT_APPLICATION: `${MODULES.SELLPURCHASE}/application/transfer-interest/checkout`,
  CHECKOUT_BUYER_APPLICATION: `${MODULES.SELLPURCHASE}/application/transfer-interest/checkout-buyer`,
  CHECKOUT_MAKER_RELEASE_APPLICATION: `${MODULES.SELLPURCHASE}/application/transfer-interest/checkout-maker-release`,
  CHECKOUT_BANK_MAKER_APPLICATION: `${MODULES.SELLPURCHASE}/application/transfer-interest/checkout-maker`,

  GET_MUSATAHA_APPLICATION_CONTRACT: `${MODULES.SELLPURCHASE}/application/long-lease-to-musataha`,
  APPROVE_MUSATAHA_APPLICATION: `${MODULES.SELLPURCHASE}/application/long-lease-to-musataha/tenant-approval`,
  CHECKOUT_MUSATAHA_APPLICATION_WAIVE: `${MODULES.SELLPURCHASE}/application/transfer-interest/checkout`,
  MUSATAHA_PAYMENT_BREATDOWN_WAIVER: `${MODULES.PAYMENT}/waiver-musataha-payment-breakdown`,
  TRANSFER_OF_INTEREST_OWNER_APPROVAL: `${MODULES.SELLPURCHASE}/application/transfer-interest/owner-approval`,
  TRANSFER_OF_INTEREST_BUYER_APPROVAL: `${MODULES.SELLPURCHASE}/application/transfer-interest/buyer-approval`,
  OWNER_APPROVE_MUSATAHA: `${MODULES.SELLPURCHASE}/application/waiver-musataha/seller-approval`,
  APPLICATION_PDF: `${MODULES.SELLPURCHASE}/application/waiver-musataha/waiver-certificate/download`,
  MUSATAHA_APPLICATION_PDF: `${MODULES.SELLPURCHASE}/application/long-lease-to-musataha/contract/download`,
  MUSATAHA_PROPERTY_DOCUMENTS: `${MODULES.PROPERTY_SERVICE}/property/latest-document`,
  APPLICATION_PDF_TENANT: `${MODULES.SELLPURCHASE}/application/waiver-musataha/contract/download`,
  OFFPLAN_INSTALLMENT_PLAN: `${MODULES.SELLPURCHASE}/application/transfer-interest/instalment-plan`, // POST
  DOWNLAOD_TRANSFER_OF_INTEREST_TITLE_DEED: `${MODULES.SELLPURCHASE}/application/transfer-interest/title-deed/download`,
  DOWNLAOD_TRANSFER_OF_INTEREST_CONTRACT: `${MODULES.SELLPURCHASE}/application/transfer-interest/contract/download`,
  DOWNLAOD_TRANSFER_OF_INTEREST_DISCHARGE_CERTIIFCATE: `${MODULES.SELLPURCHASE}/application/transfer-interest/discharge-certificate/download`,

  OFFPLAN_CONTRACT_PDF: `${MODULES.SELLPURCHASE}/application/transfer-interest/contract/download`,
  GET_NATIONALITIES: `${MODULES.AUTH}/admin/lookup/nationalities`, // GET
  BUYER_LIST: `${MODULES.AUTH}/user/adgm-user/search?sort=eid`, // GET
  ADD_BUYER_NON_RESIDENT: `${MODULES.OWNER}/non-resident/buyer`, // POST
  FETCH_GOVERNMENT_COMPANIES: `${MODULES.AUTH}/government-companies`, // POST
  ADD_BUYER: `${MODULES.SELLPURCHASE}/application/transfer-interest/buyer`, // POST

  BANK_APPROVAL: `${MODULES.SELLPURCHASE}/application/transfer-interest/bank-approval`,

  FETCH_ACTIVE_AGREEMENTS: `${MODULES.PROPERTY_SERVICE}/active-agreements`,
};

const DIGITAL_TRANSFER_OF_INTEREST = {
  BANKER_APPROVE_MORTGAGE: `${MODULES.SELLPURCHASE}/application/digital-transfer-interest/bank-approval`,
  FETCH_EXSITING_ACTIVE_PMA: `${MODULES.LEASE}/pma/contract-exists/:propertyId`,
  DIGITAL_TRANSFER_OF_INTEREST: `${MODULES.SELLPURCHASE}/application/digital-transfer-interest`, // GENERAL
  FETCH_BANK_DETAIL: `${MODULES.AUTH}/lookup/mortgage-banks`, // GET
  OFFPLAN_SELL_PAYMENT_BREAKDOWN: `${MODULES.PAYMENT}/offplan-first-sell-payment-breakdown`,
  MUSATAHA_PAYMENT_BREATDOWN: `${MODULES.PAYMENT}/long-lease-to-musataha-payment-breakdown`,
  SAVE_MUSATAHA_APPLICATION: `${MODULES.SELLPURCHASE}/application/long-lease-to-musataha/contract`,
  CHECKOUT_APPLICATION: `${MODULES.SELLPURCHASE}/application/digital-transfer-interest/checkout`,
  GET_MUSATAHA_APPLICATION_CONTRACT: `${MODULES.SELLPURCHASE}/application/long-lease-to-musataha`,
  APPROVE_MUSATAHA_APPLICATION: `${MODULES.SELLPURCHASE}/application/long-lease-to-musataha/tenant-approval`,
  CHECKOUT_MUSATAHA_APPLICATION_WAIVE: `${MODULES.SELLPURCHASE}/application/digital-transfer-interest/checkout`,
  MUSATAHA_PAYMENT_BREATDOWN_WAIVER: `${MODULES.PAYMENT}/waiver-musataha-payment-breakdown`,
  DIGITAL_TRANSFER_OF_INTEREST_OWNER_APPROVAL: `${MODULES.SELLPURCHASE}/application/digital-transfer-interest/owner-approval`,
  DIGITAL_TRANSFER_OF_INTEREST_BUYER_APPROVAL: `${MODULES.SELLPURCHASE}/application/digital-transfer-interest/buyer-approval`,
  OWNER_APPROVE_MUSATAHA: `${MODULES.SELLPURCHASE}/application/waiver-musataha/seller-approval`,
  APPLICATION_PDF: `${MODULES.SELLPURCHASE}/application/waiver-musataha/waiver-certificate/download`,
  MUSATAHA_APPLICATION_PDF: `${MODULES.SELLPURCHASE}/application/long-lease-to-musataha/contract/download`,
  MUSATAHA_PROPERTY_DOCUMENTS: `${MODULES.PROPERTY_SERVICE}/property/latest-document`,
  APPLICATION_PDF_TENANT: `${MODULES.SELLPURCHASE}/application/waiver-musataha/contract/download`,
  OFFPLAN_INSTALLMENT_PLAN: `${MODULES.SELLPURCHASE}/application/digital-transfer-interest/instalment-plan`, // POST
  DOWNLAOD_DIGITAL_TRANSFER_OF_INTEREST_CONTRACT: `${MODULES.SELLPURCHASE}/application/digital-transfer-interest/contract/download`,
  DOWNLAOD_DIGITAL_TRANSFER_OF_INTEREST_TITLE_DEED: `${MODULES.SELLPURCHASE}/application/digital-transfer-interest/title-deed/download`,
  CHECKOUT_BANK_MAKER_APPLICATION: `${MODULES.SELLPURCHASE}/application/digital-transfer-interest/checkout-maker`,

  OFFPLAN_CONTRACT_PDF: `${MODULES.SELLPURCHASE}/application/digital-transfer-interest/contract/download`,
  GET_NATIONALITIES: `${MODULES.AUTH}/admin/lookup/nationalities`, // GET
  BUYER_LIST: `${MODULES.AUTH}/user/adgm-user/search?sort=eid`, // GET
  ADD_BUYER_NON_RESIDENT: `${MODULES.OWNER}/non-resident/buyer`, // POST
  FETCH_GOVERNMENT_COMPANIES: `${MODULES.AUTH}/government-companies`, // POST
  ADD_BUYER: `${MODULES.SELLPURCHASE}/application/digital-transfer-interest/buyer`, // POST
};
const OFFPLAN = {
  FETCH_APPLICATION_OFFPLAN: `${MODULES.SELLPURCHASE}/application/off-plan`, // GET
  SAVE_APPLICATION_OFFPLAN: `${MODULES.SELLPURCHASE}/application/off-plan`, // POST
  OFFPLAN_SELL_PAYMENT_BREAKDOWN: `${MODULES.PAYMENT}/offplan-first-sell-payment-breakdown`,
  MUSATAHA_PAYMENT_BREATDOWN: `${MODULES.PAYMENT}/long-lease-to-musataha-payment-breakdown`,
  SAVE_MUSATAHA_APPLICATION: `${MODULES.SELLPURCHASE}/application/long-lease-to-musataha/contract`,
  CHECKOUT_MUSATAHA_APPLICATION: `${MODULES.SELLPURCHASE}/application/long-lease-to-musataha/checkout`,
  GET_MUSATAHA_APPLICATION_CONTRACT: `${MODULES.SELLPURCHASE}/application/long-lease-to-musataha`,
  APPROVE_MUSATAHA_APPLICATION: `${MODULES.SELLPURCHASE}/application/long-lease-to-musataha/tenant-approval`,
  CHECKOUT_MUSATAHA_APPLICATION_WAIVE: `${MODULES.SELLPURCHASE}/application/off-plan/checkout`,
  MUSATAHA_PAYMENT_BREATDOWN_WAIVER: `${MODULES.PAYMENT}/waiver-musataha-payment-breakdown`,
  SIGNATORY_APPROVE_MUSATAHA: `${MODULES.SELLPURCHASE}/application/off-plan/owner-approval`,
  OWNER_APPROVE_MUSATAHA: `${MODULES.SELLPURCHASE}/application/waiver-musataha/seller-approval`,
  APPLICATION_PDF: `${MODULES.SELLPURCHASE}/application/waiver-musataha/waiver-certificate/download`,
  MUSATAHA_APPLICATION_PDF: `${MODULES.SELLPURCHASE}/application/long-lease-to-musataha/contract/download`,
  MUSATAHA_PROPERTY_DOCUMENTS: `${MODULES.PROPERTY_SERVICE}/property/latest-document`,
  APPLICATION_PDF_TENANT: `${MODULES.SELLPURCHASE}/application/waiver-musataha/contract/download`,
  OFFPLAN_INSTALLMENT_PLAN: `${MODULES.SELLPURCHASE}/application/off-plan/instalment-plan`, // POST
  OFFPLAN_APPLICATION_PDF: `${MODULES.SELLPURCHASE}/application/off-plan/certificate/download`,
  OFFPLAN_CONTRACT_PDF: `${MODULES.SELLPURCHASE}/application/off-plan/contract/download`,
  GET_NATIONALITIES: `${MODULES.AUTH}/admin/lookup/nationalities`, // GET
  BUYER_LIST: `${MODULES.AUTH}/user/adgm-user/search?sort=eid`, // GET
  ADD_BUYER_NON_RESIDENT: `${MODULES.OWNER}/non-resident/buyer`, // POST
  FETCH_GOVERNMENT_COMPANIES: `${MODULES.AUTH}/government-companies`, // POST
};
const MORTGAGE = {
  FETCH_APPLICATION_MORTGAGE: `${MODULES.SELLPURCHASE}/application/mortgage-registration`, // GET
  FETCH_BANK_DETAIL: `${MODULES.AUTH}/lookup/mortgage-banks`, // GET
  SAVE_APPLICATION: `${MODULES.SELLPURCHASE}/application/mortgage-registration/mortgage`, // POST
  CHECKOUT_MORTGAGE_APPLICATION: `${MODULES.SELLPURCHASE}/application/mortgage-registration/checkout`,
  MORTGAGE_CONTRACT_PDF: `${MODULES.SELLPURCHASE}/application/mortgage-registration/contract/download`,
  MORTGAGE_TITLE_DEED_PDF: `${MODULES.SELLPURCHASE}/application/mortgage-registration/title-deed/download`,
  OWNER_APPROVE_MORTGAGE: `${MODULES.SELLPURCHASE}/application/mortgage-registration/owner-approval`,
  MORTGAGE_PROPERTY_DOCUMENTS: `${MODULES.PROPERTY_SERVICE}/property/latest-document`,
  /** --------------- MORTGAGE BANK MAKER --------------- */
  FETCH_MORTGAGE_TYPES: `${MODULES.PROPERTY_SERVICE}/lookup/mortgage-types`,
  FETCH_BANK_SIGNATORIES: `${MODULES.SELLPURCHASE}/application/mortgage-registration/bank-signatories`,
  FETCH_VALUATION_COMPANIES: `${MODULES.SELLPURCHASE}/application/mortgage-registration/valuation-companies`,
  FETCH_VALUATORS: `${MODULES.SELLPURCHASE}/application/mortgage-registration/valuators`,
  FETCH_VALUATORS_V2: `${MODULES.AUTH}/lookup/valuators`,
  CHECKOUT_MORTGAGE_BANK_MAKER_APPLICATION: `${MODULES.SELLPURCHASE}/application/mortgage-registration/checkout-maker`,
  BANKER_APPROVE_MORTGAGE: `${MODULES.SELLPURCHASE}/application/mortgage-registration/bank-approval`,
  FETCH_MORTGAGE_DETAILS: `${MODULES.SELLPURCHASE}/mortgage`, // GET
  DOWNLOAD_MORTGAGE_AGREEMENT_PDF: `${MODULES.SELLPURCHASE}/mortgage/contract/download`,
  FETCH_EXSITING_ACTIVE_PMA: `${MODULES.LEASE}/pma/contract-exists/:propertyId`,
};

const PRIMARY_CONTACT = {
  FETCH_CONTACTS: `${MODULES.AUTH}/contact/fetchPrimaryContact`, // POST
  FETCH_APPLICATION_CONTACTS: `${MODULES.LEASE}/application/fetch-contact`, // POST
  ADD_CONTACT: `${MODULES.AUTH}/contact/add-contact`, // POST
  ADD_APPLICATION_CONTACT: `${MODULES.LEASE}/application/primary-contact/save`, // POST
  REMOVE_CONTACT: `${MODULES.AUTH}/contact/remove-contact`, // DELETE
};

const TRANSFER_OFFPLAN = {
  FETCH_APPLICATION_TRANSFER_OFFPLAN_TO_COMPLETE: `${MODULES.SELLPURCHASE}/application/offplan-to-complete`, // GET
  SAVE_APPLICATION_TRANSFER_OFFPLAN_TO_COMPLETE: `${MODULES.SELLPURCHASE}/application/offplan-to-complete/save`, // POST
  CHECKOUT_APPLICATION_TRANSFER_OFFPLAN_TO_COMPLETE: `${MODULES.SELLPURCHASE}/application/offplan-to-complete/checkout`,
  DEVELOPER_APPROVE: `${MODULES.SELLPURCHASE}/application/offplan-to-complete/developer-approval`,
  BUYER_APPROVE: `${MODULES.SELLPURCHASE}/application/offplan-to-complete/buyer-approval`,
  PAYMENT_BREAKDOWN: `${MODULES.PAYMENT}/offplan-to-complete/payment-breakdown`,
  BANKER_APPROVE: `${MODULES.SELLPURCHASE}/application/offplan-to-complete/bank-approval`,
  CHECKOUT_BANK_MAKER_APPLICATION: `${MODULES.SELLPURCHASE}/application/offplan-to-complete/checkout-maker`,
  DOWNLOAD_CONTRACT_PDF: `${MODULES.SELLPURCHASE}/application/offplan-to-complete/contract/download`,
  DOWNLOAD_TITLE_DEED_PDF: `${MODULES.SELLPURCHASE}/application/offplan-to-complete/title-deed/download`,
};
const NHL_MORTGAGE = {
  FETCH_APPLICATION_MORTGAGE: `${MODULES.SELLPURCHASE}/application/national-housing-mortgage`, // GET
  FETCH_BANK_DETAIL: `${MODULES.AUTH}/lookup/national-housing-mortgage-bank`, // GET
  SAVE_APPLICATION: `${MODULES.SELLPURCHASE}/application/national-housing-mortgage/mortgage`, // POST
  CHECKOUT_MORTGAGE_APPLICATION: `${MODULES.SELLPURCHASE}/application/national-housing-mortgage/checkout`,
  MORTGAGE_CONTRACT_PDF: `${MODULES.SELLPURCHASE}/application/national-housing-mortgage/contract/download`,
  MORTGAGE_TITLE_DEED_PDF: `${MODULES.SELLPURCHASE}/application/national-housing-mortgage/title-deed/download`,
  OWNER_APPROVE_MORTGAGE: `${MODULES.SELLPURCHASE}/application/national-housing-mortgage/owner-approval`,
  MORTGAGE_PROPERTY_DOCUMENTS: `${MODULES.PROPERTY_SERVICE}/property/latest-document`,
  /** --------------- MORTGAGE BANK MAKER --------------- */
  FETCH_MORTGAGE_TYPES: `${MODULES.AUTH}/lookup/national-housing-mortgage-types`,
  FETCH_BANK_SIGNATORIES: `${MODULES.SELLPURCHASE}/application/national-housing-mortgage/bank-signatories`,
  FETCH_VALUATION_COMPANIES: `${MODULES.SELLPURCHASE}/application/national-housing-mortgage/valuation-companies`,
  FETCH_VALUATORS: `${MODULES.SELLPURCHASE}/application/national-housing-mortgage/valuators`,
  CHECKOUT_MORTGAGE_BANK_MAKER_APPLICATION: `${MODULES.SELLPURCHASE}/application/national-housing-mortgage/checkout-maker`,
  BANKER_APPROVE_MORTGAGE: `${MODULES.SELLPURCHASE}/application/national-housing-mortgage/bank-approval`,
};
const RENT_PAYMENT = {
  GET_ROADS: `${MODULES.AUTH}/admin/lookup/nationalities`, // GET
  FETCH_APPLICATION_RENT_PAYMENT: `${MODULES.SELLPURCHASE}/application/rent-fee-collection`, // GET
  SAVE_APPLICATION_RENT_PAYMENT: `${MODULES.SELLPURCHASE}/application/rent-fee-collection/save`, // POST
  CHECKOUT_APPLICATION_RENT_PAYMENT: `${MODULES.SELLPURCHASE}/application/rent-fee-collection/checkout`,
  CHECKOUT_BANK_MAKER_APPLICATION: `${MODULES.SELLPURCHASE}/application/rent-fee-collection/checkout-maker`,
  PAYMENT_BREAKDOWN: `${MODULES.PAYMENT}/rent-fee-collection/payment-breakdown`,
};

const OFFPLAN_TERMENTATION = {
  FETCH_APPLICATION_OFFPLAN_TERMENTATION: `${MODULES.SELLPURCHASE}/application/off-plan-termination`, // GET
  SAVE_APPLICATION_OFFPLAN_TERMENTATION: `${MODULES.SELLPURCHASE}/application/off-plan-termination`, // POST
  CHECKOUT_APPLICATION_OFFPLAN_TERMENTATION: `${MODULES.SELLPURCHASE}/application/off-plan-termination/checkout`,
  CHECKOUT_BANK_MAKER_APPLICATION: `${MODULES.SELLPURCHASE}/application/off-plan-termination/bank-checkout`,
  DOWNLOAD_CONTRACT_PDF: `${MODULES.SELLPURCHASE}/application/off-plan-termination/contract/download`,
  DOWNLOAD_RECEIPT_PDF: `${MODULES.SELLPURCHASE}/application/off-plan-termination/receipt/download`,
  GET_CONTRACT_DETAILS_BY_PROPERTY_ID: `${MODULES.SELLPURCHASE}/application/off-plan/contract-by-property`, // POST
  BUYER_APPROVE: `${MODULES.SELLPURCHASE}/application/off-plan-termination/buyer-approval`, // POST
  BANK_APPROVAL: `${MODULES.SELLPURCHASE}/application/off-plan-termination/bank-approval`, // POST
  DEVELOPER_APPROVAL: `${MODULES.SELLPURCHASE}/application/off-plan-termination/developer-approval`, // POST
  CONTRACT_DETAIL: `${MODULES.SELLPURCHASE}/application/off-plan/contract`, // GET
};

const CONSTANT = {
  FETCH_COUNTRIES: `${MODULES.AUTH}/lookup/nationalities`, // GET
  FETCH_BANKS: `${MODULES.AUTH}/lookup/mortgage-banks`, // GET
  FETCH_CITIES: `${MODULES.AUTH}/lookup/cities`, // GET
};

const REGISTER_DISPUTE = {
  // Application endpoints
  FETCH_APPLICATION_REGISTER_DISPUTE: `${MODULES.DRC}/dispute`,
  SAVE_APPLICATION_REGISTER_DISPUTE: `${MODULES.DRC}/dispute`,
  CHECKOUT_APPLICATION_REGISTER_DISPUTE: `${MODULES.DRC}/checkout`,
  APPLICATION_APPROVAL: `${MODULES.DRC}/dispute/approval`,
  APPLICATION_RESUBMIT: `${MODULES.DRC}/dispute/resubmit`,
  DOWNLOAD_DISPUTE_LETTER: `${MODULES.DRC}/dispute/drc-letter/download`,

  // helpers endpoints
  FETCH_MULTIPLE_PROPERTIES: `${MODULES.DRC}/dispute/properties`,
  SAVE_MANUAL_ADDRESS: `${MODULES.DRC}/dispute/manual/property`,
  REMOVE_MANUAL_ADDRESS: `${MODULES.DRC}/remove/manual/property`,
  ADD_NEW_LAW_FIRM_INFO: `${MODULES.OWNER}/party/poa`,
  DELETE_LAW_FIRM_INFO: `${MODULES.OWNER}/party/poa`,
  FETCH_OWNERS_DEVELOPERS: `${MODULES.DRC}/fetch/owners-developer`,
  FETCH_NON_UAE_RESIDENT_USER: `${MODULES.DRC}/fetch/nonresident-user`,
  FETCH_UAE_RESIDENT_USER: `${MODULES.DRC}/owner-service/user`,
  ADD_MANUAL_PLAINTIFF_DEFENDANT: `${MODULES.DRC}/manual/plaintiff-defendant/save`,
  ADD_EDIT_DEMAND: `${MODULES.DRC}/add-demand`,
  DELETE_DEMAND: `${MODULES.DRC}/remove-demand`,
  REMOVE_MANUAL_PLAINTIFF_DEFENDANT: `${MODULES.DRC}/manual/plaintiff-defendant/remove`,
  GET_PROPERTY_OWNER_BY_EID: `${MODULES.DRC}/fetch-owner-details`,
  FETCH_LAW_FIRM_DETAILS: `${MODULES.DRC}/fetch-law-firm`,

  // Lookups endpoints
  FETCH_DISPUTE_TYPE_LOOKUP: `${MODULES.DRC}/lookup/dispute-type`,
  FETCH_DISPUTE_SECTOR_LOOKUP: `${MODULES.DRC}/lookup/dispute-sector`,
  FETCH_DISPUTE_CATEGORY_LOOKUP: `${MODULES.DRC}/lookup/dispute-category`,
  FETCH_DISPUTE_SUBJECT_LOOKUP: `${MODULES.DRC}/lookup/dispute-subject`,
};
const REQUEST_FOR_EXPERT_OPINION = {
  FETCH_APPLICATION_REGISTER_DISPUTE: `${MODULES.DRC}/dispute`, // GET
  FETCH_MULTIPLE_PROPERTIES: `${MODULES.DRC}/dispute/properties`, // POST
  ADD_EXPERT_REPORT: `${MODULES.DRC}/expert-opinion/add-term`,
  DELETE_EXPERT_REPORT: `${MODULES.DRC}/expert-opinion/remove-term`,
  EXPERT_OPINION_CHECKOUT: `${MODULES.DRC}/expert-opinion/approval`,
  PAYMENT_BREAKDOWN: `${MODULES.PAYMENT}/breakdown`,
};
const OFFPLAN_PROJECT_REGISTRATION = {
  FETCH_DEVELOPERS: `${MODULES.SELLPURCHASE}/application/offplan-project-registration/lookup/developers`, // GET
  FETCH_APPLICATION_PROJECT_REGISTRATION: `${MODULES.SELLPURCHASE}/application/offplan-project-registration`, // GET
  SAVE_APPLICATION_PROJECT_REGISTRATION: `${MODULES.SELLPURCHASE}/application/offplan-project-registration/save`, // POST
  ADD_SELECTED_PROPERTIES: `${MODULES.SELLPURCHASE}/application/offplan-project-registration/add-properties`, // POST
  FETCH_SELECTED_PROPERTIES: `${MODULES.SELLPURCHASE}/application/offplan-project-registration/selected-properties`, // GET
  REMOVE_SELECTED_PROPERTIES: `${MODULES.SELLPURCHASE}/application/offplan-project-registration/remove-properties`, // POST
  UPLOAD_SHEET: `${MODULES.SELLPURCHASE}/application/offplan-project-registration/plot-sheet/upload`, // POST
  FETCH_SURVEYORS_LIST: `${MODULES.SELLPURCHASE}/application/offplan-project-registration/lookup/surveyors`, // GET
  SET_SURVEYOR: `${MODULES.SELLPURCHASE}/application/offplan-project-registration`, // POST
  UPLOAD_PLOTS_SHEET: `${MODULES.SELLPURCHASE}/application/offplan-project-registration/plot-sheet/upload`, // POST
  REMOVE_INVALID_PROPERTIES: `${MODULES.SELLPURCHASE}/application/offplan-project-registration/move-next`, // POST
  CHECKOUT_APPLICATION_OFFPLAN_PROJECT_REGISTRATION: `${MODULES.SELLPURCHASE}/application/offplan-project-registration/checkout`, // POST
  SAVE_APPLICATION_SURVEYING_CONSULTANT: `${MODULES.SELLPURCHASE}/application/offplan-project-registration/surveyor-update`, // POST
  CHECKOUT_APPLICATION_SURVEYING_CONSULTANT: `${MODULES.SELLPURCHASE}/application/offplan-project-registration/surveying-review`, // POST
  DEVELOPER_APPROVE: `${MODULES.SELLPURCHASE}/application/offplan-project-registration/developer-approval`, // POST
  SURVEYOR_APPROVE: `${MODULES.SELLPURCHASE}/application/offplan-project-registration/surveyor-accept`, // POST
  GET_PROPERTIES_INFORMATION: `${MODULES.SELLPURCHASE}/application/offplan-project-registration/inventory-units`, // GET
  DOWNLOAD_CONTRACT_PDF: `${MODULES.SELLPURCHASE}/application/offplan-project-registration/contract/download`,
};

const EXECUTION_STAMP = {
  FETCH_APPLICATION_EXECUTION_STAMP: `${MODULES.DRC}/dispute`, // GET
  DOWNLOAD_EXECUTION_STAMP_LETTER: `${MODULES.DRC}/dispute/execution-stamp/download`,
  PAYMENT_BREAKDOWN: `${MODULES.PAYMENT}/breakdown`, // GET
  FETCH_CASES: `${MODULES.DRC}/dispute/search-settled-cases`, // GET
};
const ADD_COMPANY_EMPLOYEE = {
  FETCH_APPLICATION_ADD_COMPANY_EMPLOYEE: `${MODULES.OWNER}/employee/fetch-employee`, // GET
  SAVE_APPLICATION_ADD_COMPANY_EMPLOYEE: `${MODULES.OWNER}/employee/save-employee`, // POST
  FETCH_EMPLOYEE_PERMISSIONS: `${MODULES.OWNER}/employee/permission`,
  FETCH_USER_BY_ID: `${MODULES.OWNER}/user`, // GET
  FETCH_COMPANY_BY_LICENSE: `${MODULES.OWNER}/fetch-company/license`, // GET
  CHECKOUT_APPLICATION_ADD_EMPLOYEE: `${MODULES.OWNER}/employee/checkout`, // GET
  APPLICATION_APPROVAL: `${MODULES.OWNER}/company-admin-approval`, // POST
  SUBMIT_BY_COMPANY_ADMIN: `${MODULES.OWNER}/employee/checkout-company-admin`, // POST
};

const ESCROW_ACCOUNT = {
  APPLICATION_DETAILS: `${MODULES.SELLPURCHASE}/application/escrow-account-registration`, // POST
  FETCH_ACCOUNT_TRUSTEE: `${MODULES.SELLPURCHASE}/application/escrow-account-registration/lookup/account-keepers`,
  SAVE_AGREEMENT_DETAILS: `${MODULES.SELLPURCHASE}/application/escrow-account-registration`,
  CHECKOUT_APPLICATION: `${MODULES.SELLPURCHASE}/application/escrow-account-registration/checkout`,
  SAVE_APPLICATION: `${MODULES.SELLPURCHASE}/application/escrow-account-registration`,
  ADD_CONDITION: `${MODULES.SELLPURCHASE}/application/escrow-account-registration/add-conditions`,
  REMOVE_CONDITION: `${MODULES.SELLPURCHASE}/application/escrow-account-registration/remove-conditions`,
  EDIT_CONDITION: `${MODULES.SELLPURCHASE}/application/escrow-account-registration`,

  ADD_FEES_SCHEDULE: `${MODULES.SELLPURCHASE}/application/escrow-account-registration/add-admin-fee-schedule`,
  REMOVE_FEES_SCHEDULE: `${MODULES.SELLPURCHASE}/application/escrow-account-registration/remove-admin-fee-schedule`,
  EDIT_FEES_SCHEDULE: `${MODULES.SELLPURCHASE}/application/escrow-account-registration`,

  DOWNLOAD_CONTRACT: `${MODULES.SELLPURCHASE}/application/escrow-account-registration/download-contract`,
  BANK_MAKER_CHECKOUT: `${MODULES.SELLPURCHASE}/application/escrow-account-registration/checkout-maker`,
  DEVELOPER_APPROVAL: `${MODULES.SELLPURCHASE}/application/escrow-account-registration/developer-approval`,
  BANK_CHECKER_APPROVAL: `${MODULES.SELLPURCHASE}/application/escrow-account-registration/bank-approval`,
  BANK_SIGNATORY_APPROVAL: `${MODULES.SELLPURCHASE}/application/escrow-account-registration/bank-signatory-approval`,
  DEVELOPER__SIGNATORY_APPROVAL: `${MODULES.SELLPURCHASE}/application/escrow-account-registration/developer-signatory-approval`,
  REJECT_WITH_REASON: `${MODULES.WORKFLOW}/application/cancel`,
  FETCH_BREAKDOWN: `${MODULES.PAYMENT}/escrow-account/payment-breakdown`,
};

const ESCROW_SERVICE_PROVIDER_PAYMENT = {
  APPLICATION_DETAILS: `${MODULES.SELLPURCHASE}/application/service-provider-payment`, // POST
  INSPECTION_COMPANY_LIST: `${MODULES.SELLPURCHASE}/application/service-provider-payment/inspection-company`, // GET
  COMPANIES: `${MODULES.AUTH}/companies`,
  SERVICE_PROVIDER: `${MODULES.SELLPURCHASE}/application/service-provider-payment/service-provider`,
  CHECKOUT_APPLICATION: `${MODULES.SELLPURCHASE}/application/service-provider-payment/checkout`,
  ADD_PROGRESS_DETAILS: `${MODULES.SELLPURCHASE}/application/service-provider-payment`, // POST
  ADD_DELETE_INSPECTION_COMPANY: `${MODULES.OWNER}/party/inspection-company`, // POST
  DEVELOPER_APPROVAL: `${MODULES.SELLPURCHASE}/application/service-provider-payment/developer-approval`,
  INSPECTION_COMPANY_APPROVAL: `${MODULES.SELLPURCHASE}/application/service-provider-payment/inspection-company-approval`,
  BANK_APPROVAL: `${MODULES.SELLPURCHASE}/application/service-provider-payment/bank-approval`,
  ACCEPT_TASK: `${MODULES.SELLPURCHASE}/application/service-provider-payment/accept-application`,
  REJECT_WITH_REASON: `${MODULES.WORKFLOW}/application/cancel`,
  FINAL_APPROVAL: `${MODULES.SELLPURCHASE}/application/service-provider-payment/final-approval`,
  FETCH_DISBURSEMENTS_LIST: `${MODULES.SELLPURCHASE}/application/service-provider-payment/disbursements-list`, // GET
};

const REGISTER_COMPANY = {
  FETCH_CITIES: `${MODULES.AUTH}/lookup/cities`, // GET
  FETCH_EMIRATE: `${MODULES.AUTH}/lookup/emirate`, // GET
  SUBMIT_APPLICATION: `${MODULES.OWNER}/submit`, // POST
};
const UPDATE_COMPANY = {
  APPLICATION_DETAILS: `${MODULES.OWNER}/fetch-company`, // GET
  CITIES_SOURCE: `${MODULES.AUTH}/lookup/cities`,
  CHECKOUT_APPLICATION: `${MODULES.OWNER}/submit`, // POST,
  PUSH_UPDATED_PROFILE: `${MODULES.OWNER}/update-company-per-ded`,
};

const RELEASE_MORTGAGE = {
  FETCH_APPLICATION_RELEASE_MORTGAGE: `${MODULES.SELLPURCHASE}/application/mortgage-release`, // GET
  FETCH_MULTI_PROPERTY: `${MODULES.WORKFLOW}/application/properties`, // GET
  FETCH_MULTI_PROPERTY_WITHOUT_APP_ID: `${MODULES.SELLPURCHASE}/mortgage/properties`, // GET
  SAVE_APPLICATION_RELEASE_MORTGAGE: `${MODULES.OWNER}/employee/save-employee`, // POST
  CHECKOUT_APPLICATION_RELEASE_MORTGAGE: `${MODULES.SELLPURCHASE}/application/mortgage-release/checkout`, // POST
  BANK_MAKER_CHECKOUT_APPLICATION_RELEASE_MORTGAGE: `${MODULES.SELLPURCHASE}/application/mortgage-release/checkout-maker`, // POST
  OWNER_APPROVAL: `${MODULES.SELLPURCHASE}/application/mortgage-release/owner-approval`, // POST
  MAKER_APPROVAL: `${MODULES.SELLPURCHASE}/application/mortgage-release/bank-approval`, // POST
  CHECKER_APPROVAL: `${MODULES.SELLPURCHASE}/application/mortgage-release/bank-approval`, // POST
  PAYMENT_BREAKDOWN: `${MODULES.PAYMENT}/payment-breakdown`,
  DOWNLOAD_CONTRACT: `${MODULES.SELLPURCHASE}/application/mortgage-release/contract/download`, // GET
  DOWNLOAD_TITLE_DEED: `${MODULES.SELLPURCHASE}/application/mortgage-release/title-deed/download`, // GET
  PROPERTY_OWNERS_MORTGAGE: `${MODULES.SELLPURCHASE}/mortgage-property-owner`, // GET
  MORTGAGE_TITLE_DEED_PDF: `${MODULES.SELLPURCHASE}/application/mortgage-release/title-deed/download`,
  MORTGAGE_TITLE_DEED_PDF_CONTRACT: `${MODULES.SELLPURCHASE}/mortgage/title-deed/download`,
};

const REGSITER_POA = {
  FETCH_APPLICATION_REGISTER_POA: `${MODULES.OWNER}/fetch-poa`, // GET
  SAVE_APPLICATION_REGISTER_POA: `${MODULES.OWNER}/add-poa`, // POST
  FETCH_ENTITY_DETAILS: `${MODULES.OWNER}/poa/search-parties`, // POST
  FETCH_POA_BY_POA_NUMBER: `${MODULES.OWNER}/poa/poa-details`, // GET
  FETCH_COMPANY_BY_LICENSE: `${MODULES.OWNER}/fetch-company/license`, // GET
  CHECKOUT_APPLICATION_REGISTER_POA: `${MODULES.OWNER}/poa/checkout`, // GET
  APPLICATION_APPROVAL: `${MODULES.OWNER}/company-admin-approval`, // POST
  FETCH_POA_TYPES_LOOKUP: `${MODULES.OWNER}/poa/lookup/poa-types`, // GET
  FETCH_POA_CLASSIFICATION_LOOKUP: `${MODULES.OWNER}/poa/lookup/poa-classification-types`, // GET
  FETCH_POA_CONTRACT_DETAILS: `${MODULES.OWNER}/poa/fetch-contract`, // GET
  FETCH_MULTI_PROPERTIES_FOR_CONTRACT: `${MODULES.LEASE}/contract/properties`, // POST
  FETCH_MULTI_PROPERTIES_FOR_APPLICATION: `${MODULES.WORKFLOW}/application/properties`, // POST
  TERMINATE_POWER_OF_ATTORNEY: `${MODULES.OWNER}/poa-terminate/submit`, // POST
  ADD_EDIT_PARTY: `${MODULES.OWNER}/poa/add-party`, // POST
  DELETE_PARTY: `${MODULES.OWNER}/poa/:applicationId/party/:partyId`, // DELETE
};

const PROFILE = {
  FETCH_PROFILE_APPLICATION: `${MODULES.OWNER}/profile/fetch-profile`,
  ADD_PROFILE: `${MODULES.OWNER}/profile/add-profile`,
  CHECKOUT_PROFILE_APPLICATION: `${MODULES.OWNER}/profile/checkout`,
};

const INSTANT_SREVICES = {
  FETCH_APPLICATION_DETAILS: `${MODULES.SELLPURCHASE}/instant-services`,
  SUBMIT_APPLICATION: `${MODULES.SELLPURCHASE}/instant-services/checkout`,
};

const CERTIFICATES = {
  FETCH_APPLICATION_DETAILS: `${MODULES.SELLPURCHASE}/certificates`,
  SUBMIT_APPLICATION: `${MODULES.SELLPURCHASE}/certificates/checkout`,
  CERTIFICATES_APPLICATION_PDF: `${MODULES.SELLPURCHASE}/certificates/certificate/download`,
  FETCH_OWNERSHIP_PROPERTIES: `${MODULES.SELLPURCHASE}/certificates/ownership-properties`,
};

const MORTGAGE_MODIFICATION = {
  FETCH_APPLICATION_MORTGAGE_MODIFICATION: `${MODULES.SELLPURCHASE}/application/mortgage-modification`, // GET
  SAVE_APPLICATION_MORTGAGE_MODIFICATION: `${MODULES.SELLPURCHASE}/application/mortgage-modification/mortgage`, // PUT
  CHECKOUT_APPLICATION_MORTGAGE_MODIFICATION: `${MODULES.SELLPURCHASE}/application/mortgage-modification/checkout`, // POST
  FETCH_MULTI_PROPERTIES_FOR_APPLICATION: `${MODULES.SELLPURCHASE}/application/mortgage-modification/properties`, // POST
  DELETE_PROPERTY_FROM_MORTGAGE: `${MODULES.SELLPURCHASE}/application/mortgage-modification/delete-property`,
  CALCULATE_FEES: `${MODULES.PAYMENT}/payment-breakdown/calculate-by-input`, // POST
  BANK_MAKER_CHECKOUT: `${MODULES.SELLPURCHASE}/application/mortgage-modification/checkout-maker`, // POST
  BANK_MAKER_RELEASE_CHECKOUT: `${MODULES.SELLPURCHASE}/application/mortgage-modification/checkout-maker-release`, // POST
  FETCH_MORTGAGE_TYPES_LOOKUPS: `${MODULES.PROPERTY_SERVICE}/lookup/mortgage-types`,
  FETCH_VALUATION_COMPANIES_LOOKUPS: `${MODULES.SELLPURCHASE}/application/mortgage-registration/valuation-companies`,
  FETCH_BANK_SIGNATORIES_LOOKUPS: `${MODULES.SELLPURCHASE}/application/mortgage-registration/bank-signatories`,
  FETCH_VALUATORS_LOOKUPS: `${MODULES.AUTH}/lookup/valuators`,
  OWNER_APPROVAL: `${MODULES.SELLPURCHASE}/application/mortgage-modification/owner-approval`, // POST
  DOWNLOAD_CONTRACT: `${MODULES.SELLPURCHASE}/application/mortgage-modification/contract/download`, // GET
  DOWNLOAD_TITLE_DEED: `${MODULES.SELLPURCHASE}/application/mortgage-modification/title-deed/download`, // GET
  BANK_APPROVAL: `${MODULES.SELLPURCHASE}/application/mortgage-modification/bank-approval`, // POST
  PROPERTY_OWNERS: `${MODULES.SELLPURCHASE}/application/mortgage-modification/mortgage-property-owner`, // GET
  MORTGAGE_CONTRACT_PROPERTY_OWNERS: `${MODULES.SELLPURCHASE}/mortgage/mortgage-property-owner`, // GET
};
const LEGAL_NOTICE = {
  CONTRACT_DETAIL: `${MODULES.SELLPURCHASE}/application/off-plan/contract`,
  FETCH_APPLICATION_DETAILS: `${MODULES.SELLPURCHASE}/application/legal-notice`,
  SAVE_NOTIFICATION_DETAILS: `${MODULES.SELLPURCHASE}/application/legal-notice`,
  CHECKOUT: `${MODULES.SELLPURCHASE}/application/legal-notice/checkout`,
  DEVELOPER_APPROVAL: `${MODULES.SELLPURCHASE}/application/legal-notice/developer-approval`,
};
// DOT NET
const DOT_WORKFLOW = {
  INITIATE_DOTNET_APPLICATION: `${MODULES.DOT_NET_V1}/application/initiate`,
};

const REQUEST_PERMIT = {
  FETCH_APPLICATION: `${MODULES.DOT_NET_V1}/application`,
  CHECKOUT_APPLICATION: `${MODULES.DOT_NET_V1}/application/submit`,
  SAVE_APPLICATION: `${MODULES.DOT_NET_V1}/permit-advetisement/save`,
  ADD_BROKER: `${MODULES.DOT_NET_V1}/permit-advetisement/add-broker`,
  REMOVE_BROKER: `${MODULES.DOT_NET_V1}/permit-advetisement/remove-broker`,
  VALIDATE_BROKER: `${MODULES.DOT_NET_V1}/permit-advetisement/validate-broker`,
  GET_BUILDINGS_BY_PAGE: `${MODULES.DOT_NET_V1}/permit-advetisement/buildings`,
  GET_UNITS_BY_PAGE: `${MODULES.DOT_NET_V1}/permit-advetisement/units`,

  BROKER_APPROVAL: `${MODULES.DOT_NET_V1}/permit-advetisement/broker-approval`,
  BROKER_RETURN: `${MODULES.DOT_NET_V1}/permit-advetisement/broker-return`,

  OWNER_APPROVAL: `${MODULES.DOT_NET_V1}/permit-advetisement/owner-approval`,
  OWNER_RETURN: `${MODULES.DOT_NET_V1}/permit-advetisement/owner-return`,

  REMOVE_PROPERTIES: `${MODULES.DOT_NET_V1}/permit-advetisement/delete-properties`,
  DOWNLOAD_PERMIT: `${MODULES.DOT_NET_V1}/permit-advetisement/Downloadcertificate`,
};

export {
  BASE_URL,
  MODULES,
  AUTH,
  PROJECTION,
  ACCOUNT,
  WALLET,
  WORKFLOW,
  PROPERTY,
  USER,
  PROPERTY_SERVICE,
  PAYMENT,
  DOCUMENT,
  LEASE,
  SELLPURCHASE,
  OWNER,
  CONTRACTLISTING,
  PMA,
  MUSATAHA,
  OFFPLAN,
  MORTGAGE,
  PRIMARY_CONTACT,
  TRANSFER_OFFPLAN,
  NHL_MORTGAGE,
  RENT_PAYMENT,
  OFFPLAN_TERMENTATION,
  DEVELOPER,
  CONSTANT,
  REGISTER_DISPUTE,
  OFFPLAN_PROJECT_REGISTRATION,
  REQUEST_FOR_EXPERT_OPINION,
  EXECUTION_STAMP,
  ADD_COMPANY_EMPLOYEE,
  ESCROW_ACCOUNT,
  ESCROW_SERVICE_PROVIDER_PAYMENT,
  REGISTER_COMPANY,
  UPDATE_COMPANY,
  RELEASE_MORTGAGE,
  REGSITER_POA,
  PROFILE,
  INSTANT_SREVICES,
  CERTIFICATES,
  MORTGAGE_MODIFICATION,
  TRANSFER_OF_INTEREST,
  DIGITAL_TRANSFER_OF_INTEREST,
  LEGAL_NOTICE,
  DOT_WORKFLOW,
  REQUEST_PERMIT,
};
